import type { FC } from 'react';
import { MarketTable } from '@/account/dashboard/MarketTable';
import { cn } from '@/shared/react';

type MarketSectionProps = {
  className?: string;
};

export const MarketSection: FC<MarketSectionProps> = ({ className }) => {
  return (
    <section className={cn('bg-background-disabled/40', className)}>
      <div className="max-w-desktop mx-auto px-3 pb-16 desktop:pb-20 flex flex-col gap-widget">
        <MarketTable className="w-full bg-background-primary" />
      </div>
    </section>
  );
};
